<template>
	<div class="departmental_regulation">
		<p>
			<i class="el-icon-s-home"></i>
			网站首页/ 政策法规/ 部门规章
		</p>
		<ul>
			<li v-for="(item, index) in list" :key="index">
				<span @click="detail(item.id)">{{item.title}}</span>
				<el-divider></el-divider>
			</li>
		</ul>
		<el-pagination :page-size="12" @current-change='currentPageNum' :background="true" layout="total, prev, pager, next" :total="total"></el-pagination>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				total: 0,
			};
		},
		mounted() {
			this.getData(1)
		},
		methods: {
			// 当前页
			currentPageNum(val) {
				this.getData(val)
			},
			// 获取数据
			getData(pageNum) {
				this.$axios({
					url: 'http://copyright.gzcc315.com/policiesClassify',
					methods: 'get',
					data: {
						pageNum: pageNum,
						type: '部门规章'
					}
				}).then(res => {
					this.list = res.data.pageData;
					this.total = res.data.total;
				})
			},
			// 详情页
			detail(id) {
				this.$router.replace({path: '/policies/detail', query: { id: id }})
			}
		},
	};
</script>
<style scoped>
	.departmental_regulation > p {
		width: 100%;
		border-bottom: 1px solid #ddd;
		padding-bottom: 10px;
		color: gray;
	}
	.departmental_regulation > p i {
		margin-right: 10px;
	}
	
	.departmental_regulation > p span:hover {
		color: #016fb8;
		cursor: pointer;
	}
	
	.departmental_regulation ul {
		margin-top: 10px;
	}
	
	.departmental_regulation ul li {
		color: gray;
		font-size: 13px;
	}
	
	.departmental_regulation ul li span:hover {
		color: #016fb8;
		border-bottom: 1px solid #016fb8;
		cursor: pointer
	}
</style>
